export interface PulsarWebSocketConfig {
  reconnectDelayMs: number
  reconnectAttemptsBeforeOfflineScreen: number
}

export const DEFAULT_PULSAR_WEBSOCKET_CONFIG: PulsarWebSocketConfig = {
  reconnectDelayMs: 10000,
  reconnectAttemptsBeforeOfflineScreen: 3
}
